/**
 * these match up to urls
 */
export type HandoverStepType =
  | 'meeting'
  | 'resilience'
  | 'notes'
  | 'risk'
  | 'risknotes'
  | 'goals'
  | 'requirements'
  | 'requirements-builder'
  | 'tasks'
  | 'summary'
  | 'report';

export enum handoverStepRoutes {
  meeting = 'meeting',
  resilience = 'resilience',
  notes = 'notes',
  goals = 'goals',
  risk = 'risk',
  risknotes = 'risknotes',
  requirements = 'requirements',
  requirements_builder = 'requirements-builder',
  tasks = 'tasks',
  summary = 'summary',
  report = 'report',
}

export type stepValidationType = Omit<
  Record<HandoverStepType, boolean | null>,
  'summary'
>;

export const handoverStepOrder: HandoverStepType[] = [
  'meeting',
  'resilience',
  'notes',
  'goals',
  'risk',
  'risknotes',
  'requirements',
  'requirements-builder',
  'tasks',
  'summary',
  'report',
];
